import {BOOKING, CLIENT_PACKAGE, EVENT} from '@constants/resources';
import {SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';

export const authorizationObjectBooking = {
    [BOOKING]: SECURITY_PRIVILEGES_UPDATE,
};

export const authorizationObjectEvent = {
    [EVENT]: SECURITY_PRIVILEGES_UPDATE,
};

export const authorizationObjectClientPackage = {
    [CLIENT_PACKAGE]: SECURITY_PRIVILEGES_UPDATE,
};
